import { Billboard, showContact } from '@foxrenderfarm/common'
import { Button, ChatContent, ChatDesc, ChatTitle, ChatWrapper } from './atoms'
import { getImage, IGatsbyImageData, withArtDirection } from 'gatsby-plugin-image'
import { graphql, useStaticQuery } from 'gatsby'
import { Arrow } from './svg/arrow'

const query = graphql`
  query {
    chatBg: file(relativePath: { eq: "home/chat-bg.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, breakpoints: [1920], layout: FULL_WIDTH, placeholder: BLURRED)
      }
    }
    chatBgMb: file(relativePath: { eq: "home/chat-bg-mb.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: BLURRED)
      }
    }
  }
`

interface Props {
  hiddenInPC?: boolean
}

export const ChatSupport = ({ hiddenInPC }: Props) => {
  const { chatBg, chatBgMb } = useStaticQuery(query)

  return (
    <ChatWrapper $hiddenInPC={hiddenInPC}>
      <ChatContent>
        <ChatTitle>{"Can't find what you're looking for?"}</ChatTitle>
        <ChatDesc>Contact us to get your issue resolved as soon as possible.</ChatDesc>
        <Button onClick={showContact}>
          Chat now with support <Arrow />
        </Button>
      </ChatContent>
      <Billboard
        image={withArtDirection(getImage(chatBg) as IGatsbyImageData, [
          {
            media: '(max-width: 600px)',
            image: getImage(chatBgMb) as IGatsbyImageData,
          },
        ])}
        alt='Chat now with support'
      />
    </ChatWrapper>
  )
}
